// components/reports/reportStyles.js
// Plain inline-style objects for the report templates — the portal frontend
// is CRA/MUI, not Tailwind, so the marketing site's Tailwind-class version
// of these components can't be reused verbatim here.
export const card = {
  marginTop: 16,
  overflow: "hidden",
  borderRadius: 16,
  border: "1px solid #e2e2e2",
  background: "#fff",
  color: "#333",
  // Print-safe — keeps a section's heading and its content from being torn
  // apart across a page boundary when downloaded/printed via react-to-print.
  breakInside: "avoid",
  WebkitColumnBreakInside: "avoid",
};

export const sectionBar = {
  background: "#575555",
  padding: "10px 16px",
  fontSize: 14,
  fontWeight: 700,
  color: "#fff",
};

export const textBlock = {
  whiteSpace: "pre-line",
  padding: "12px 16px",
  fontSize: "0.84rem",
  lineHeight: 1.6,
  color: "#575555",
};

export const innerCard = {
  overflow: "hidden",
  borderRadius: 12,
  border: "1px solid #e2e2e2",
  background: "#fff",
  // Same print-safety as `card` above — this is the wrapper actually used
  // around each individual section (Results Summary, Clinical Summary,
  // genotype/history tables, Interpretation, Methodology, Disclaimer,
  // References), so this is the one that matters most for PDF pagination.
  breakInside: "avoid",
  WebkitColumnBreakInside: "avoid",
};

export const table = {
  width: "100%",
  textAlign: "left",
  fontSize: "0.8rem",
  borderCollapse: "collapse",
};

export const th = {
  background: "#575555",
  color: "#fff",
  padding: "8px 12px",
};

export const td = {
  padding: "6px 12px",
  borderTop: "1px solid #eee",
};
